(function() {
'use strict';

angular
    .module('TR')
    .service('trackingPixelsService', trackingPixelsService);

function trackingPixelsService($filter, cookieService, rtbHouseTrackingService, $http) {
    let data = { bookingRef: '', costing: { totalCost: 0, currencyCode: '' }, area: '' };
    const flightBookingPrefix = 'SCH';
    const hotelBookingPrefix = 'ACM';
    const bundleBookingPrefix = 'BND';
    const marhabaBookingPrefix = 'MHB';
    const insuranceBookingPrefix = 'INS';
    const transferBookingPrefix = 'TRN';

    const service = {
        getAllProviderUrls,
        getProviderCheckoutUrl,
        getProviderUrl,
        setData,
        report
    };

    function _getBookingId(bookingId) {
        const prefixExp = new RegExp(`(${flightBookingPrefix}|${hotelBookingPrefix}|${bundleBookingPrefix}|${marhabaBookingPrefix}|${insuranceBookingPrefix}|${transferBookingPrefix})/\\d+`, 'g');

        bookingId = bookingId.split('|').find(id => {
            return id.search(prefixExp) >= 0;
        });

        if (bookingId && bookingId.indexOf('/') > -1) {
            bookingId = bookingId.split('/')[1];
        }

        return bookingId || '';
    }

    function _getResponsysUrl(bookingRef) {
        if (TRPCONFIG.Domain.EmailTrackingResponsysEnabled === true) {
            return String.format(
                        'https://travel-emails.com/pub/cct?_ri_=X0Gzc2X%3DWQpglLjHJlTQGutsofCUcwSzgFS7mu5D0zaD6&_ei_=EphKD9rSZWWLEMSCymwyZgs&action=once&OrderId={0}&OrderTotal={1}',
                        bookingRef, data.costing.totalCost);
        }

        return null;
    }

    function report(eventType, source) {
        const provider = _getProvider(source);
        const eventData = {
            VisitSource: source,
            EventType: eventType,
            ClickId: provider.clickId,
            BookingId: parseInt(provider.bookingId)
        };

        $http.post('/api2/b2b/tpe/', eventData);
    }

    function setData(bookingRefs, currencyCode, totalCost, hotel, rooms, tripType) {
        if (bookingRefs && totalCost) {
            data = {
                bookingRef: bookingRefs.join('|'),
                costing: { totalCost, currencyCode }
            };
        } else {
            data.bookingRef = '';
        }

        if (hotel) {
            data.hotel = hotel;
        }

        if (rooms) {
            data.rooms = rooms;
        }

        if (tripType) {
            data.area = rtbHouseTrackingService.tripStates[tripType];
        }

        return data;
    }

    function _getProvider(source) {
        let provider = {
            name: 'unknown',
            source: source || 'unknown',
            bookingId: _getBookingId(data.bookingRef),
            clickId: ''
        };

        if (source) {
            switch (source.toLowerCase()) {
                case 'kyhdnuae':
                case 'kyh':
                case 'ky':
                    provider.name = 'kayak';
                break;
                case 'tv':
                    provider.name = 'trivago';
                break;
                case 'skyh':
                    provider.name = 'skyscanner';
                break;
                case 'we':
                case 'weksa':
                    provider.name = 'wego';
                break;
                case 'clickwise':
                    provider.name = 'clickwise';
                break;
            }

            provider.clickId = cookieService.get(`${provider.name}_referral`);
        }

        return provider;
    }

    function getProviderCheckoutUrl(provider, bookingData) {
        let providerUrl = '';

        switch (provider.toLowerCase()) {
            case 'roomerflex':
                providerUrl = _getRoomerFlexCheckoutUrl(bookingData.quoteId);
                break;
        }

        return providerUrl;
    }

    function getProviderUrl(provider, bookingRef) {
        let providerUrl = '';

        switch (provider.toLowerCase()) {
            case 'responsys':
                providerUrl = _getResponsysUrl(bookingRef);
            break;
            case 'trivago':
                providerUrl = _getTrivagoUrl();
            break;
            case 'kayak':
                providerUrl = _getKayakUrl();
            break;
            case 'skyscanner':
                providerUrl = _getSkyScannerUrl();
            break;
            case 'wego':
                providerUrl = _getWegoUrl();
            break;
            case 'dcm':
                providerUrl = _getDcmUrl();
            break;
            case 'rtbhouse':
                providerUrl = _getRtbHouseUrl();
            break;
            case 'speeti':
                providerUrl = _getSpeetiUrl();
            break;
            case 'arabyads':
                providerUrl = _getArabyadsUrl();
            break;
            case 'clickwise':
                providerUrl = _getClickwiseUrl();
            break;
            case 'roomerflex':
                providerUrl = _getRoomerFlexConfirmationUrl(bookingRef);
            break;
        }

        return providerUrl;
    }

    function _getTrivagoUrl() {
        let domain = TRPCONFIG.Domain.CultureCode.split('-');
        domain = domain && domain.length > 1 ? domain[1].toUpperCase() : '';

        if (getProviderEnabled('trivago', ['partnerId', 'cookie']) && data.hotel) {
            return String.format('https://secde.trivago.com/page_check.php?pagetype=track&ref={0}&hotel={1}&arrival={2}&departure={3}&currency={4}&volume={5}&domain={6}&booking_id={7}&date_format=Y-m-d',
                    TRPCONFIG.Domain.TrivagoPartnerId,
                    data.hotel.Details.Id,
                    $filter('date')(new Date(data.hotel.Details.Itinerary.CheckInDate), 'yyyy-MM-dd'),
                    $filter('date')(new Date(data.hotel.Details.Itinerary.CheckOutDate), 'yyyy-MM-dd'),
                    data.costing.currencyCode,
                    data.costing.totalCost,
                    domain,
                    _getBookingId(data.bookingRef)
                    );
        }

        return null;
    }

    function _getKayakUrl() {
        if (getProviderEnabled('kayak', ['partnerId', 'cookie'])) {
            return String.format('https://www.kayak.com/s/kayakpixel/confirm/{0}?kayakclickid={1}&price={2}&currency={3}&confirmation={4}&rand={5}',
            TRPCONFIG.Domain.KayakPartnerId,
            cookieService.get('kayak_referral'),
            data.costing.totalCost,
            data.costing.currencyCode,
            _getBookingId(data.bookingRef),
            new Date().getTime()
            );
        }
    }

    function _getSkyScannerUrl() {
        if (getProviderEnabled('skyscanner', ['partnerId', 'cookie'])) {
            if (!data.hotel || !data.rooms) {
                const eventData = {
                    VisitSource: 'SKYH',
                    EventType: 'error',
                    ClickId: cookieService.get('skyscanner_referral'),
                    BookingId: _getBookingId(data.bookingRef),
                    Msg: 'Provider enabled, insufficient data'
                };
                return $http.post('/api2/b2b/tpe/', eventData).then(() => {
                    return null;
                });
            }

            return String.format('https://t.skyscnr.com/hotels/track/booking?fclid={0}&partner={1}&order_id={2}&hotel_id={3}&hotel_name={4}&hotel_city={5}&hotel_country={6}&checkin={7}&checkout={8}&guests={9}',
                cookieService.get('skyscanner_referral'),
                TRPCONFIG.Domain.SkyscannerPartnerId,
                _getBookingId(data.bookingRef),
                data.hotel.Details.Id,
                data.hotel.Details.Itinerary.Title,
                data.hotel.Details.Itinerary.Province,
                data.hotel.Details.Itinerary.Country,
                $filter('date')(new Date(data.hotel.Details.Itinerary.CheckInDate), 'yyyy-MM-dd'),
                $filter('date')(new Date(data.hotel.Details.Itinerary.CheckOutDate), 'yyyy-MM-dd'),
                data.rooms.map(room => {
                    return room.Guests.length;
                }).reduce((total, value) => {
                    return total + value;
                }) || 0)
                .concat(String.format('&rooms={0}&amount={1}&currency={2}',
                data.rooms.length || 0,
                data.costing.totalCost,
                data.costing.currencyCode
                ));
        }
    }

    function _getWegoUrl() {
        const commission = '';
        if (getProviderEnabled('wego', ['partnerId', 'cookie']) && TRPCONFIG.Domain.WegoConversionCodeID !== '') {
            return String.format('https://secure.{0}.com/analytics/v2/conversions?conversion_id={1}&click_id={2}&comm_currency_code={3}&bv_currency_code={4}&transaction_id={5}&commission={6}&total_booking_value={7}&status={8}',
            TRPCONFIG.Domain.WegoConversionTarget || 'wego',
            TRPCONFIG.Domain.WegoConversionCodeID,
            cookieService.get('wego_referral'),
            data.costing.currencyCode,
            data.costing.currencyCode,
            _getBookingId(data.bookingRef),
            commission,
            data.costing.totalCost,
            'confirmed'
            );
        }
    }

    function _getDcmUrl() {
        if (getProviderEnabled('dcm')) {
            return String.format('https://go.urtrackinglink.com/aff_l?offer_id={0}&adv_sub={1}&amount={2}',
                TRPCONFIG.Domain.DcmTrackingPixelOfferId,
                _getBookingId(data.bookingRef),
                data.costing.totalCost);
        }
    }

    function _getSpeetiUrl() {
        if (getProviderEnabled('speeti')) {
            return String.format('https://speetiiaffiliates.com/p.ashx?o={0}&e={1}&p={2}&t={3}&udid={2}',
                TRPCONFIG.Domain.SpeetiTrackingPixelDomainId,
                _setSpeetiBookingType(data.bookingRef),
                data.costing.totalCost,
                _getBookingId(data.bookingRef));
        }
    }

    function _getArabyadsUrl() {
        if (getProviderEnabled('arabyads')) {
            return String.format('https://www.arabytracking.net/aff_l?offer_id={0}8&amount={1}&adv_sub={2}&adv_sub2={3}',
                TRPCONFIG.Domain.ArabyadsTrackingPixelOfferId,
                data.costing.totalCost,
                _getBookingId(data.bookingRef),
                _setArabyadsBookingType(data.bookingRef));
        }
    }

    function _getClickwiseUrl() {
        if (getProviderEnabled('clickwise', ['cookie']) && TRPCONFIG.Domain.ClickwiseUrl !== '') {
            return String.format(TRPCONFIG.Domain.ClickwiseUrl,
                cookieService.get('clickwise_referral'),
                _setClickwiseBookingType(data.bookingRef),
                _getBookingId(data.bookingRef),
                data.costing.totalCost,
                data.costing.currencyCode);
        }
    }

    function _getRtbHouseUrl() {
        if (TRPCONFIG.Domain.EnabledRtbHouseTracking) {
            if (data.hotel) {
                return String.format(`${TRPCONFIG.Domain.RTBHouseTrackingURL}`
                    + `?type=img${TRPCONFIG.Domain.RTBHouseOptionId}_orderstatus2_`
                    + '{0}_{1}-{2}_{3}'
                    + `&amp;cd=default${TRPCONFIG.Domain.RTBHouseOptionId}_custom_type_{1}`
                    + `${TRPCONFIG.Domain.RTBHouseOptionId}_uid_{4}`,
                    data.costing.totalCost || null,
                    data.area || 'hotels',
                    _getBookingId(data.bookingRef),
                    data.hotel.Details && data.hotel.Details.Id || null,
                    rtbHouseTrackingService.setUID());
            }

            return rtbHouseTrackingService.getDefaultUrl();
        }
    }

    function _getRoomerFlexConfirmationUrl(bookingRef) {
        bookingRef = bookingRef || _.chain(window.dataLayer)
            .find(item => item.event === 'RoomerflexQuoteId')
            .get('QuoteId')
            .value();

        if (getProviderEnabled('roomerFlex', ['partnerId']) && bookingRef) {
            let roomerflexItem = _.find(window.dataLayer, item => item.event === 'RoomerflexQuoteId');
            if (roomerflexItem) {
                roomerflexItem.event = null;
            }
            return String.format(`${TRPCONFIG.Domain.RoomerflexPixelUrl}/register.jpg?partner={0}&token={1}`,
                TRPCONFIG.Domain.RoomerflexPartnerId,
                bookingRef);
        }
    }

    function _getRoomerFlexCheckoutUrl(quoteId) {
        if (getProviderEnabled('roomerFlex', ['partnerId'])) {
            return String.format(`${TRPCONFIG.Domain.RoomerflexPixelUrl}/request.jpg?partner={0}&token={1}`,
                TRPCONFIG.Domain.RoomerflexPartnerId,
                quoteId);
        }
    }

    function _setSpeetiBookingType(bookingRef) {
        let speetiBookingType = 0;
        if (TRPCONFIG.Domain.TenantId === 3) {
            speetiBookingType = TRPCONFIG.Domain.SpeetiTrackingPixelBookingType;
        } else if (TRPCONFIG.Domain.TenantId === 2) {
            const bookingCodes = [30, 29, 31, 32, 33, 34];
            speetiBookingType = bookingCodes[(_getBookingType(bookingRef) - 1)];
        }
        return speetiBookingType;
    }

    function _setArabyadsBookingType(bookingRef) {
        return _getBookingType(bookingRef).toString();
    }

    function _setClickwiseBookingType(bookingRef) {
        const bookingTypes = ['flights', 'hotels', 'holidays', 'marhaba', 'insurance', 'transfer'];
        return bookingTypes[(_getBookingType(bookingRef) - 1)];
    }

    function _getBookingType(bookingRef) {
        let bookingTypeId = 0;

        if (bookingRef.split('|').length > 0) {
            return 3;
        }

        const bookingType = bookingRef.substring(0, 3);
        switch (bookingType.toUpperCase()) {
            case flightBookingPrefix:
                bookingTypeId = 1;
            break;
            case hotelBookingPrefix:
                bookingTypeId = 2;
            break;
            case bundleBookingPrefix:
                bookingTypeId = 3;
            break;
            case marhabaBookingPrefix:
                bookingTypeId = 4;
            break;
            case insuranceBookingPrefix:
                bookingTypeId = 5;
            break;
            case transferBookingPrefix:
                bookingTypeId = 6;
            break;
        }
        return bookingTypeId;
    }

    function getProviderEnabled(provider, checks) {
        let enabled = false;
        if (provider) {
            provider = provider.toLowerCase();
            const ucFirst = provider.charAt(0).toUpperCase() + provider.slice(1);

            if (TRPCONFIG.Domain[`${ucFirst}TrackingPixelEnabled`]) {
                enabled = true;
                if (checks && checks.length) {
                    enabled = checks.every(check => {
                        switch (check) {
                            case 'cookie':
                                return cookieService.get(`${provider}_referral`) != null;
                            case 'partnerId':
                                return TRPCONFIG.Domain[`${ucFirst}PartnerId`] !== '';
                        }
                        return false;
                    });
                }
            }
        }
        return enabled;
    }

    function getAllProviderUrls(bookingRefs, options) {

        const addUrl = (name, url, trackingLabel) => {
            if (url && url.length > 0) {
                return { trackingLabel: trackingLabel || '', url, name };
            }
        };

        const providers = [
            {
                name: 'responsys',
                bookingRef: bookingRefs[0]
            },
            {
                name: 'trivago',
                label: 'TV'
            },
            {
                name: 'kayak',
                label: cookieService.get('kayak_source') || ''
            },
            {
                name: 'skyscanner',
                label: 'SKYH'
            },
            {
                name: 'dcm'
            },
            {
                name: 'speeti'
            },
            {
                name: 'arabyads'
            },
            {
                name: 'clickwise',
                label: 'CLICKWISE'
            },
            {
                name: 'rtbHouse'
            },
            {
                name: 'wego'
            },
            {
                name: 'roomerflex',
                bookingRef: options && options.cancellationProtectionRef
            }
        ];

        return _.compact(providers.map(provider => {
            return addUrl(provider.name,
                service.getProviderUrl(provider.name, provider.bookingRef),
                provider.label
            );
        }));
    }

    return service;
}
})();
